import { lazy } from 'react';
import { SearchIcon } from '@tools/ui/assets';
import type { AppRouter } from '@tools/ui/types';

export const BASE_PATH = '/user-valid-phones';

const UserValidPhonesView = lazy(
  () =>
    import(
      /* webpackChunkName: "UserValidPhonesRoutes" */ '../pages/UserValidPhonesView'
    )
);

export const userValidPhonesRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [BASE_PATH, `${BASE_PATH}/*`]
    },
    {
      name: 'Valid phones',
      path: `${BASE_PATH}/lookup`,
      component: UserValidPhonesView,
      exact: false,
      icon: SearchIcon,
      pages: []
    }
  ]
};
